import React from 'react';
import { Helmet } from 'react-helmet';

import CardSuccess from 'components/CardSuccess';
import { MFA_VERIFY_CODE_EMAIL_SUCCESS_TITLE } from 'constants/pageTitles';
import {
  MFA_EMAIL_VERIFIED_TITLE,
  MFA_EMAIL_VERIFIED_DESC,
} from 'constants/commonConstants';
import { SEGURIDAD_ROUTE } from 'constants/RouterConstants';

const EmailMFAConfiguracionExitosaContainer = () => (
  <div>
    <Helmet title={MFA_VERIFY_CODE_EMAIL_SUCCESS_TITLE} />
    <CardSuccess
      title={MFA_EMAIL_VERIFIED_TITLE}
      description={MFA_EMAIL_VERIFIED_DESC}
      returnUrl={SEGURIDAD_ROUTE}
      headerText="Entendido"
    />
  </div>
);

export default EmailMFAConfiguracionExitosaContainer;
